// extracted by mini-css-extract-plugin
export default {"societyImage":"SocietyCard_societyImage__K+rmo","a_wrapper":"SocietyCard_a_wrapper__Qa61t"};